var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM28.513 10.7797C29.5712 10.6531 30.5801 10.3726 31.5176 9.95613C30.8164 11.005 29.929 11.9263 28.9057 12.6658C28.9167 12.8893 28.921 13.1154 28.921 13.3423C28.921 20.2549 23.659 28.2265 14.0368 28.2265C11.0824 28.2265 8.33282 27.3596 6.01758 25.8756C6.4264 25.9249 6.84287 25.9495 7.26614 25.9495C9.71738 25.9495 11.9731 25.1123 13.7631 23.7099C11.4742 23.6674 9.54144 22.1545 8.87594 20.0764C9.19551 20.1376 9.52359 20.1707 9.86102 20.1707C10.3378 20.1707 10.8002 20.1062 11.2388 19.9872C8.84704 19.5052 7.04261 17.3914 7.04261 14.8561V14.7906C7.74891 15.1824 8.55466 15.4179 9.4131 15.4451C8.00814 14.5067 7.08596 12.9054 7.08596 11.0908C7.08596 10.1321 7.34349 9.23368 7.79396 8.46108C10.3744 11.6263 14.2289 13.7095 18.5772 13.9271C18.4879 13.5437 18.4412 13.1443 18.4412 12.7346C18.4412 9.84564 20.7836 7.50319 23.6726 7.50319C25.1761 7.50319 26.5369 8.13895 27.4914 9.15548C28.6822 8.92005 29.8032 8.48572 30.813 7.88566C30.4228 9.10703 29.5933 10.1321 28.513 10.7797Z",
    fill: "#0065FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.fe94c201e663d33c3a280c12646b380d.svg";
export { ForwardRef as ReactComponent };